import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CartItem } from 'models/cartItem';

@Component({
    selector: 'da-hotels-list',
    templateUrl: './hotels-list.component.html',
    styleUrls: ['./hotels-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotelsListComponent implements OnInit {
    @Input() events: CartItem[];
    public haveHotels: boolean = false;
    constructor() {}

    ngOnInit() {
        if (this.events)
            this.events.forEach((event) => {
                if (event.location && event.location.hotels && event.location.hotels.length > 0) {
                    this.haveHotels = true;
                    return;
                }
            });
    }
}
